import { create } from 'zustand';
import { getCardIndexService, type Flashcard } from '../lib/cards/card-index-service';

interface CardsState {
  cards: Flashcard[];
  isLoading: boolean;
  error: string | null;
  loadIndex: () => Promise<void>;
  addCard: (card: Omit<Flashcard, 'id' | 'created_at'>) => Promise<void>;
  getCardsForNote: (noteId: string) => Flashcard[];
}

export const useCardsStore = create<CardsState>((set, get) => ({
  cards: [],
  isLoading: false,
  error: null,

  loadIndex: async () => {
    // Prevent duplicate loading
    if (get().isLoading) return;
    try {
      set({ isLoading: true, error: null });
      const service = getCardIndexService();
      const index = await service.getIndex();
      set({ cards: index.cards, isLoading: false });
    } catch (err) {
      set({ error: err instanceof Error ? err.message : 'Unknown error', isLoading: false });
    }
  },

  addCard: async (cardData) => {
    try {
      const service = getCardIndexService();
      const index = await service.getIndex();

      const newCard: Flashcard = {
        ...cardData,
        id: 'card_' + Date.now().toString(36) + Math.random().toString(36).substring(2),
        created_at: Date.now(),
      };

      index.cards.push(newCard);
      await service.updateIndex(index);
      set({ cards: [...index.cards] });
    } catch (err) {
      console.error('[CardsStore] Failed to add card:', err);
      throw err;
    }
  },

  getCardsForNote: (noteId: string) => {
    return get().cards.filter(c => c.source_note_id === noteId);
  },
}));
